<template>
  <div class="uso-usuarios-container">
    <CardPrime class="uso-usuarios-card">
      <template #title>
        <h3 class="card-title">Uso de Usuarios</h3>
      </template>
      <template #content>
        <div class="p-grid p-align-center">
          <div class="p-col-12 p-md-4">
            <label for="uso-select">Seleccionar Opción:</label>
            <select v-model="selectedOpcion" @change="cargarUsuarios" class="p-inputtext p-component">
              <option value="0">Sin Uso</option>
              <option value="1">Con Uso</option>
            </select>
          </div>

          <div class="p-col-12 p-md-4">
            <div class="service-selection">
              <ButtonPrime 
                label="Estudyoo Nativo" 
                :class="{ 'p-button-success': selectedService === 'nativo' }" 
                @click="selectService('nativo')" 
              />
              <ButtonPrime 
                label="Estudyoo One" 
                :class="{ 'p-button-success': selectedService === 'one' }" 
                @click="selectService('one')" 
              />
            </div>
          </div>

          <div class="p-col-12 p-md-4">
            <ColegioDropdown 
              v-model="selectedColegio" 
              @change="cargarUsuarios" 
              :mostrarErrores="false" 
              :tooltip="''" 
              :error="''"
            />
          </div>
        </div>

        <ButtonPrime label="Cargar Usuarios" @click="cargarUsuarios" class="p-mt-2" />
        
        <DataTable v-if="usuarios.length > 0" :value="usuarios" class="p-mt-3" dataKey="id_usuario" selection-mode="multiple" v-model:selection="selectedUsuarios">
          <ColumnPrime selectionMode="multiple" headerStyle="width: 3em" />
          <ColumnPrime field="id_usuario" header="ID Usuario" />
          <ColumnPrime field="email" header="Email" />
          <ColumnPrime field="dias" header="Días" />
          <ColumnPrime header="Acciones">
            <template #body="slotProps">
              <ButtonPrime label="Invitar" 
                @click="invitar(slotProps.data)" 
              />
            </template>
          </ColumnPrime>
        </DataTable>
        
        <p v-else>No hay usuarios disponibles.</p>
        <ButtonPrime label="Notificar EMAIL Seleccionados" @click="openEmailModalSelect" v-if="selectedUsuarios.length > 0" class="p-mt-2" />
      </template>
    </CardPrime>

    <!-- Modal para opciones de notificación -->
    <DialogPrime header="Opciones de Notificación" v-model:visible="showEmailModal" :modal="true" :closable="false">
      <div>
        <p>Selecciona la opción de Email:</p>
        <div>
          <label>
            <input type="radio" v-model="selectedNotificationOption" value="Estadisticas Alumnos Opción A" />
            Estadísticas Alumnos Opción A
          </label>
        </div>
        <div>
          <label>
            <input type="radio" v-model="selectedNotificationOption" value="Email por No Uso" />
            Email por No Uso
          </label>
        </div>
        <ButtonPrime label="Enviar" @click="confirmarNotificacion" />
        <ButtonPrime label="Cancelar" @click="closeEmailModal" class="p-button-secondary" />
      </div>
    </DialogPrime>
  </div>
</template>

<script>
import usuarioService from '@/services/UsuarioService';
import notiService from '@/services/NotiService';
import ColegioDropdown from '@/components/selectores/ColegioDropdown.vue'; 
import DataTable from 'primevue/datatable'; 
import ColumnPrime from 'primevue/column'; 
import DialogPrime from 'primevue/dialog'; 

export default {
  components: {
    ColegioDropdown,
    DataTable,
    ColumnPrime,
    DialogPrime
  },
  data() {
    return {
      usuarios: [],
      selectedOpcion: '0',
      selectedUsuarios: [],
      selectedService: 'nativo',
      selectedColegio: '',
      showEmailModal: false,
      selectedNotificationOption: '',
      errors: {
        cursos: ''
      },
      mostrarErrores: false
    };
  },
  methods: {
    selectService(service) {
      this.selectedService = service;
      this.cargarUsuarios();
    },
    async cargarUsuarios() {
      try {
        const response = await usuarioService.consultarUso({ 
          "opc": Number(this.selectedOpcion), 
          "colegio_id": this.selectedColegio 
        }, this.selectedService);
        this.usuarios = response.data;
        this.selectedUsuarios = [];
      } catch (error) {
        console.error('Error al cargar usuarios:', error);
      }
    },
    openEmailModalSelect() {
      this.showEmailModal = true; // Abre el modal
    },
    closeEmailModal() {
      this.showEmailModal = false; // Cierra el modal
      this.selectedNotificationOption = ''; // Reinicia la opción de notificación seleccionada
    },
    async confirmarNotificacion() {
      if (this.selectedNotificationOption === 'Estadisticas Alumnos Opción A') {
        for (const user of this.selectedUsuarios) {
          const body = { usuario_id: user.id_usuario, email: user.email };
          try {
            const response = await notiService.emailEstadisticasAlumnoOpcionA(body);
            console.log(`Notificación por email enviada a usuario ID: ${user.id_usuario}`, response.data);
          } catch (error) {
            console.error('Error al enviar notificación por email:', error);
          }
        }
      } else if (this.selectedNotificationOption === 'Email por No Uso') {
        for (const user of this.selectedUsuarios) {
          const body = { email: user.email };
          try {
            const response = await notiService.emailNoUsoAlumno(body);
            console.log(`Notificación por email de No Uso enviada a usuario ID: ${user.id_usuario}`, response.data);
          } catch (error) {
            console.error('Error al enviar notificación por email de No Uso:', error);
          }
        }
      }
      this.closeEmailModal(); // Cierra el modal después de enviar todas las notificaciones
    },
    invitar(usuario) {
      // Lógica para enviar la invitación
      this.showEmailModal = true; 
      this.selectedUsuarios.push(usuario);
    }
  }
};
</script>

<style scoped>
.uso-usuarios-container {
  padding: 1rem;
}

.uso-usuarios-card {
  background: var(--surface-card);
  border-radius: var(--border-radius);
  padding: 1rem;
}

.card-title {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-color);
}
</style>